import React from "react";
import { Check } from "lucide-react";

// Small progress ring + checklist of what's left on a seafarer profile
export const ProfileCompleteness = ({ items, onOpen }) => {
  const done = items.filter((i) => i.done).length;
  const pct = Math.round((done / items.length) * 100);
  if (pct === 100) return null;
  const r = 18;
  const c = 2 * Math.PI * r;

  return (
    <button type="button" onClick={onOpen} data-testid="profile-completeness"
      className="mt-4 flex w-full items-center gap-3 rounded-xl border border-gray-200 bg-white p-3 text-left transition-colors hover:border-slate-300 hover:bg-slate-50">
      <span className="relative h-11 w-11 shrink-0">
        <svg viewBox="0 0 44 44" className="h-11 w-11 -rotate-90">
          <circle cx="22" cy="22" r={r} fill="none" stroke="#f1f5f9" strokeWidth="4" />
          <circle cx="22" cy="22" r={r} fill="none" stroke="#FF4500" strokeWidth="4" strokeLinecap="round"
            strokeDasharray={c} strokeDashoffset={c * (1 - pct / 100)} className="transition-[stroke-dashoffset] duration-700" />
        </svg>
        <span className="absolute inset-0 flex items-center justify-center text-[11px] font-extrabold text-gray-900" data-testid="profile-completeness-pct">{pct}%</span>
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-xs font-bold text-gray-900">Complete your profile</span>
        <span className="mt-1 flex flex-wrap gap-1">
          {items.map((i) => (
            <span key={i.label} data-testid={`completeness-${i.key}`}
              className={`inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-[10px] font-semibold ${i.done ? "bg-emerald-50 text-emerald-700" : "bg-orange-50 text-[#FF4500]"}`}>
              {i.done && <Check className="h-2.5 w-2.5" strokeWidth={3} />}{i.label}
            </span>
          ))}
        </span>
      </span>
    </button>
  );
};

export default ProfileCompleteness;
